module.exports = __webpack_public_path__ + "static/media/bandeira_mercosul.bc69903e.png";